import { ConfigInterface } from './config.interface';
import { environment } from '@environments/environment';

export type ConfigState = ConfigInterface;

export const initialConfigState: ConfigState = {
  ...window['NAConfig'],
  ...environment
};
